export const AGENT_HOST = __ENV_CONFIG__.MYPARTNER;
export const AGENTPROXY_HOST = __ENV_CONFIG__.AGENTPROXY_HOST;
const MYPARTNER_SSR_HOST = __ENV_CONFIG__.MYPARTNER_SSR_HOST;
export const REGISTER_API = `${AGENT_HOST}/agents/register/`;
export const RESENT_OTP_API = `${AGENT_HOST}/agents/generate/`;
export const UPLOAD_PAN_API = `${AGENT_HOST}/agents/pan/`;
export const UPLOAD_KYC_API = `${AGENT_HOST}/agents/supporting-document/`;
export const LOGIN_API = `${AGENT_HOST}/agents/login/`;
export const PRE_REGISTER_API = `${AGENT_HOST}/agents/lead/`;
export const SET_PASSWORD_URL = `${AGENT_HOST}/agents/account/`;
export const UPDATE_PASSWORD_URL = `${AGENT_HOST}/agents/change_password/`;
export const CHANGE_PASSWORD = `${AGENT_HOST}/agents/change_password/otp/`;
export const TERMS_URL = `${AGENT_HOST}/agents/terms-and-conditions/`;
export const PINCODE_API_URL = `${AGENT_HOST}/system/pincode/`;
export const SUBSCRIBERID_UPDATE = `${AGENT_HOST}/agents/web-push`;
export const IS_LOGGED_IN_URL = `${MYPARTNER_SSR_HOST}/agents/loggedin/`;
export const REDIRECT_REQUEST_URL = `${MYPARTNER_SSR_HOST}/register/redirect_user`;

export const HOME_PAGE_URL = '/agent/home/v1/';
export const VERIFY_PAGE_URL = '/agent/verify/';
export const UPDATE_PASSWORD = '/agent/updatePassword/';
export const DETAILS_PAGE_URL = '/agent/details/';
export const UPDATE_PAGE_URL = '/agent/update/';
export const REGISTERED_PAGE_URL = '/agent/registered/';
export const VERIFICATION_PAGE_URL = '/agent/verification/';
export const LOGIN_PAGE_URL = '/agent/login/';
export const MOBILE_END_PAGE_URL = '/agent/mobile';

export const NON_EDITABLE_STATUS = ['confirmed', 'approved', 'manual', 'active'];

export const MYTRIP_URL = '/mytrips/';
export const HOTELS_HOME_URL = '/hotels/';
export const HOTELS_HOME_URL_OLD = `${AGENT_HOST}/hotels/v1/`;
export const HOTELS_HOME_URL_NEW = `${AGENT_HOST}/hotels/`;
export const showOldHeaderUrlList = [
  '/mywallet/',
  '/mysettings/',
  '/hotels/v1/',
  '/hotels/',
  '/mytrips/',
  '/myterinationagreement',
  '/myloyaltyagreement',
];

//new flow api's
export const GET_TOKEN_DATA = `${AGENT_HOST}/register/get_token_data/`;
export const SUBMIT_NUMBER = `${AGENT_HOST}/register/enter/`;
export const SUBMIT_DETAILS = `${AGENT_HOST}/register/business_detail/`;
export const SUBMIT_KYCDOC = `${AGENT_HOST}/register/collect_kyc/`;
export const CREATE_PASSWORD = `${AGENT_HOST}/register/setup_account/`;
export const SAVE_AGREEMENT = `${AGENT_HOST}/register/save_agreement/`;

// export const SUBMIT_NUMBER = `${AGENT_HOST}/register/enter/`;

// new page url
export const HOME_PAGE_URL_NEW = '/agent/home';
export const VERIFY_OTP_NEW_URL = '/agent/otpverify';
export const AGENCY_DETAILS_NEW_URL = '/agent/agencydetails';
export const DOCUMENT_UPLOAD_KYC_URL = '/agent/agencykyc/';
export const LOGIN_WITH_MMT_PASSWORD_URL = '/agent/userpassword/';
export const CREATE_PASSWORD_PAGE_URL = '/agent/createpassword';
export const TERMS_CONDITIONS_PAGE_URL = '/agent/tnc';
export const ACCOUNT_CREATED_PAGE_URL = '/agent/success';
export const ACCOUNT_MANUAL_PAGE_URL = '/agent/manual';
export const LOGIN_URL_NEW = '/agent/login/new';
export const LOYALTY_PAGE_URL = '/agent/loyalty/hero/';
export const AGREEMENT_PAGE_URL = '/agent/agreement';
export const SUB_USER_OTP_VERIFICATION = '/subuser/otpverification';
export const SUB_USER_OTP_VERIFIED = '/agent/subuser/otpverified';
export const SUB_USER_CREATE_ACCOUNT = '/agent/subuser/createaccount';

//tnc url
export const GET_AGREEMENT = `${AGENT_HOST}/agents/user-agreement/`;
export const GET_FAQ_TNC = `${AGENT_HOST}/common/faq_tnc_data/`;

//loyalty dashboard
export const GET_DASHBOARD_DATA = `${AGENT_HOST}/agents/hero-dashboard`;
export const GET_LOYALTY_TEMPLATE = `${AGENT_HOST}/common/loggedout-herodashboard`;
//email otp on login
export const EMAIL_ACTIVATION = `${AGENT_HOST}/register/email-activation-request/`;

//GCC Onboarding url
export const LICENSE_UPLOAD_URL = '/agent/upload-license';
export const UPLOAD_PASSPORT_DETAILS = '/agent/upload-passport-details';
export const SUBMIT_NUMBER_GCC = '/agent/mobile-verification-gcc';

//GCC Onboarding api endpoints
export const UPLOAD_LICENSE_DETAILS = `${AGENT_HOST}/gcc/ocr-trade-license-validate/`;
export const UPLOAD_TRN_DETAILS = `${AGENT_HOST}/gcc/save-business-details-against-token`;
export const SUBMIT_PASSPORT_DETAILS = `${AGENT_HOST}/gcc/ocr-passport-details-validate/ `;
export const GET_TERMS_AND_CONDTIONS_GCC = `${AGENT_HOST}/gcc/terms-and-conditions/`;
export const SAVE_TERMS_AND_CONDITIONS_GCC = `${AGENT_HOST}/gcc/save-agreement/`;
export const SUBMIT_MOBILE_NUMBER = `${AGENT_HOST}/agents/update_mobile/`;

//pan verification on login
export const PAN_VERIFICATION = `${AGENT_HOST}/agents/pan-verification`;
export const GET_TDS_SLAB = `${AGENT_HOST}/agents/get-tds-slab`;

//Mobile Verification on Login
export const MOBILE_VERIFICATION_GCC = `${AGENT_HOST}/gcc/mobile-activation-request/`;
export const MAX_RETRY_LIMIT = 3;
export const UPDATE_LOB = 'UPDATE_LOB';
